import { useTranslation } from '@nextgen-web-framework/all';
import { QtyStepper } from '../qty-stepper/QtyStepper';
import styles from './QtySelectorSubCart.module.scss';

export type QtySelectorSubCartProps = {
  onQuantityChange?: (count: number) => void;
  initialCount: number;
  accountName: string;
  accontNumber: number;
  disable?: boolean;
  disableMinusButton?: boolean;
  enableHoverEffect?: boolean;
};

const QtySelectorSubCart = ({
  onQuantityChange = () => null,
  initialCount,
  accontNumber,
  accountName,
  disableMinusButton = false,
  disable = false,
  enableHoverEffect = true,
}: QtySelectorSubCartProps) => {
  const t = useTranslation();
  return (
    <div className={styles['active-cart-card']}>
      <div className={styles['active-cart-card-details']}>
        <div className={`${styles['active-cart-card-details-name']} ${disable && styles['disable']}`}>
          {accountName}
        </div>
        {Boolean(accontNumber) && (
          <div className={`${styles['active-cart-card-details-account']} ${disable && styles['disable']}`}>
            {`${t('cart.cartEllipsesMenu.accountNum')} ${accontNumber}`}
          </div>
        )}
      </div>
      <QtyStepper
        enableHoverEffect={enableHoverEffect}
        miniusButtonDisabled={disableMinusButton}
        disableQtyStepper={disable}
        onQuantityChange={onQuantityChange}
        initialCount={initialCount}
      />
    </div>
  );
};

export { QtySelectorSubCart };
